export default __webpack_public_path__ + "static/gw2-icon-getting-started-6640a32c9d8c8c7c0c88eebc2f45e212.png";